import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
export function App() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <main className="w-full min-h-screen bg-white font-sans" data-id="element-0">
      <Hero onCTAClick={scrollToOffer} data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyFailed data-id="element-4" />
      <Mechanism data-id="element-5" />
      <Deliverables data-id="element-6" />
      <ForWhom data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer id="offer" data-id="element-10" />
      <Closing onCTAClick={scrollToOffer} data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}